/* eslint-disable no-restricted-syntax */
/* eslint-disable import/prefer-default-export */
import lod_ from "lodash";
import { v4 } from "uuid";
/**
 * Create a datas skeleton from a dictionary
 * @param {*} dictionary
 * @param {*} values
 * @returns
 */
export function createDictionarySkeleton(dictionary, values = {}, path = null) {
	if (dictionary.items) {
		dictionary = dictionary.items;
	}

	let metadatas = {};
	let keys = Object.keys(dictionary);

	// Special handle for empty object in dictionary but we have a value in values
	if (keys.length === 0) {
		let possibleValue = lod_.get(values, path);
		if (possibleValue) {
			return possibleValue;
		}
	}

	keys.map(key => {
		let item = dictionary[key];

		let tempPath = `${path ? `${path}.` : ""}${key}`;

		if (item.type === "level" && item.isArray) {
			// It's an array of objects, we need to create a new array
			let possibleValue = lod_.get(values, tempPath);
			let defaultValue = item.defaultValue ?? undefined;
			if (
				!lod_.isNil(possibleValue) ||
				(lod_.isString(possibleValue) && !lod_.isEmpty(possibleValue))
			) {
				defaultValue = possibleValue;
			}
			if (lod_.isNil(defaultValue) || lod_.isEmpty(defaultValue)) {
				defaultValue = [];
			} else if (!lod_.isArray(defaultValue)) {
				defaultValue = [defaultValue];
			}
			const parsedValues = [];

			for (let value of defaultValue) {
				let resValue = createDictionarySkeleton(item.items, value);
				parsedValues.push(resValue);
			}

			// Set value on object at actual key
			lod_.set(metadatas, key, parsedValues);
		} else if (item.type === "level") {
			// If it's a level, we need to check childrens
			lod_.set(metadatas, key, createDictionarySkeleton(item.items, values, tempPath));
		} else {
			// Get possible value with full path
			let possibleValue = lod_.get(values, tempPath);
			// Set value
			let defaultValue = item.defaultValue ?? undefined;

			if (
				!lod_.isNil(possibleValue) ||
				(lod_.isString(possibleValue) && !lod_.isEmpty(possibleValue))
			) {
				defaultValue = possibleValue;
			}
			switch (item.type) {
				case "uuid":
					defaultValue = defaultValue ?? v4();
					break;
				case "boolean":
					if (lod_.isBoolean(possibleValue)) {
						defaultValue = possibleValue;
					}
					if (!lod_.isBoolean(defaultValue)) {
						defaultValue = false;
					}
					defaultValue = defaultValue ?? false;
					break;
				case "number":
					defaultValue = defaultValue ?? (item?.isArray ? [] : 0);
					break;
				case "delay":
					defaultValue = defaultValue ?? 0;
					break;
				case "date":
					if (defaultValue === "now") {
						defaultValue = new Date();
					}
					break;
				case "actions":
					if (!lod_.isArray(defaultValue)) {
						defaultValue = [];
					}
					defaultValue = defaultValue ?? [];
					break;
				case "conditions":
					if (!lod_.isArray(defaultValue)) {
						defaultValue = [];
					}
					break;
				case "string":
				default:
					if (item?.isArray && !lod_.isArray(defaultValue)) {
						if (
							!lod_.isNil(defaultValue) &&
							!lod_.isEmpty(defaultValue) &&
							lod_.isString(defaultValue)
						) {
							defaultValue = [defaultValue];
						} else {
							defaultValue = [];
						}
					}
					defaultValue = defaultValue ?? (item?.isArray ? [] : "");
					break;
			}

			// Set value on object at actual key
			lod_.set(metadatas, key, defaultValue);
		}
	});

	return metadatas;
}
